import { useEffect, useState } from "react";
import { fetchPublishedRoutes } from "../api/routes";
import { DEFAULT_ROUTE_PATH, normalizePath, previewQueryPath, currentLocationPath } from "../paths";

let cachedRoutes = null;

export function useSiteRoute() {
  const [routes, setRoutes] = useState(cachedRoutes || []);
  const [ready, setReady] = useState(Boolean(cachedRoutes));
  const [path, setPath] = useState(() => currentLocationPath());

  useEffect(() => {
    let cancelled = false;
    fetchPublishedRoutes()
      .then((items) => {
        cachedRoutes = items;
        if (!cancelled) setRoutes(items);
      })
      .catch(() => {
        if (!cancelled) setRoutes(cachedRoutes || []);
      })
      .finally(() => {
        if (!cancelled) setReady(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const onPop = () => setPath(currentLocationPath());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  const current =
    routes.find((item) => normalizePath(item.path) === path) ||
    (path === "/"
      ? routes.find((item) => normalizePath(item.path) === normalizePath(DEFAULT_ROUTE_PATH)) ||
        routes[0]
      : null);

  useEffect(() => {
    const targetPath = current?.path || (path === "/" ? DEFAULT_ROUTE_PATH : null);
    if (!targetPath) return;
    if (current?.title) {
      document.title = `Great Leaders Academy | ${current.title}`;
    }
    if (previewQueryPath()) return;
    const canonical = `${normalizePath(targetPath)}/`;
    const now = path;
    if (now === "/" || now === normalizePath(targetPath)) {
      if (window.location.pathname !== canonical) {
        window.history.replaceState(null, "", canonical);
        if (now === "/") setPath(normalizePath(targetPath));
      }
    }
  }, [current, path]);

  return { routes, current, ready, path };
}
